import { Grid } from '@mui/material';
import { HSpacer, VSpacer } from '@nx-smartmonkey/ui';

import Text from '../../../react-components/Text';

interface ChartCustomTooltipDataProps {
  label: string;
  value: number;
  color: string;
}

interface ChartCustomTooltipProps {
  label: string;
  data: Array<ChartCustomTooltipDataProps>;
  previousChange?: number;
}

const ChartCustomTooltip = ({ label, data, previousChange }: ChartCustomTooltipProps) => {
  const getPreviousChangeColor = (value?: number) => {
    if (!value || value === 0) return `#979898`;
    if (value > 0) return `#70D292`;
    return `#E03030`;
  };

  return (
    <div
      style={{
        backgroundColor: `#707070`,
        padding: `16px`,
        borderRadius: `8px`,
      }}
    >
      {data.map((entry) => (
        <Grid container direction="row" alignItems="center">
          <Text variant="body-large" style={{ color: entry.color, fontWeight: `bold` }}>
            {entry.value}
          </Text>
          <HSpacer small />
          <Text variant="body-large" style={{ color: `white`, textTransform: `lowercase` }} isBold>
            {entry.label}
          </Text>
        </Grid>
      ))}

      <VSpacer small />

      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        <Text style={{ color: getPreviousChangeColor(previousChange) }}>
          {previousChange || previousChange === 0 ? `${previousChange}%` : ``}
        </Text>
        <Text style={{ fontSize: `11px`, color: `white` }} isBold>
          {label}
        </Text>
      </Grid>
    </div>
  );
};

export default ChartCustomTooltip;
